import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import { Test } from "@app/definitions/types"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { WysiwygComponent } from "@app/utils/wysiwyg/wysiwyg.component"
import { GenSelectComponent } from "@app/gen-inputs/gen-select/gen-select.component"
import { TestquestionsManageComponent } from "@app/testquestions-manage/testquestions-manage.component"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"
import { BtnExtComponent, SpinOrContent } from "@app/utils/utils.component"
import { TestscalesComponent } from "@app/testscales/testscales.component"

@Component({
	selector: "app-update-test",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		GenInputComponent,
		WysiwygComponent,
		GenSelectComponent,
		TestquestionsManageComponent,
		GenButtonGroupComponent,
		SpinOrContent,
		TestscalesComponent,
		BtnExtComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./update-test.component.html",
})
export class UpdateTestComponent extends Modalable {
	@Input() test: Test | null = null //the test object to update
	tests: any[] = []
	isSaving: boolean = false
	errors: any = {} //will hold errors for the fields in the form
	isFormSubmittable: boolean = false //can submit (controls disabled in the submit button)
	validationFields: any = {
		//field validations, control displaying field errors and ability to submit the form
		name: { not_empty: true, unique: true },
	}
	spinDup: boolean = false
	testscalesIsOpen: boolean = false
	testquestionsIsOpen: boolean = true

	ngOnInit() {
		if (!this.test) {
			this.test = new Test()
		}
		this.tests = this.store.getSiteDataTable("tests")
	}
	validateAndSave(fieldName: string) {
		if (!this.test?.id) {
			return this.validateEntireForm()
		}
		this.validateEntireForm()
		this.saveField(fieldName)
	}

	validateEntireForm() {
		//validate all fields and detrmine if can be submitted (or has errors)
		this.isFormSubmittable = this.validator.validateEntireForm(
			this.test,
			this.errors,
			this.validationFields,
			this.tests
		)
	}

	async saveField(fieldName: string) {
		//save the test
		if (!this.isFormSubmittable) {
			return
		}

		const res: any = await this.apiService.save_gen_field(
			"tests",
			this.test?.id,
			fieldName,
			this.test?.[fieldName]
		)
		if (res?.success) {
			this.store.updGenItemRowField(
				"tests",
				this.test?.id,
				fieldName,
				this.test?.[fieldName]
			)
			this.modalService.openToast("update_successfuly")
		} else {
			this.modalService.openToast("save_failed")
		}
	}

	async save() {
		//save the contact
		if (!this.isFormSubmittable) {
			return
		}
		await this.apiService.sendApiGetPerms()
		if (
			!this.apiService.apiCallPerms ||
			!this.apiService.apiCallPerms["tests"]?.saveNewRow
		) {
			return
		}
		this.isSaving = true
		const res: any = await this.apiService.save_gen_item("tests", {
			...this.test,
		})
		this.isSaving = false
		if (res.id) {
			this.test = res
			this.store.addGenItemRow("tests", res)
			this.store.refreshTableSubject.next("tests")
		}
		this.modalService.openToast(
			res?.id ? "saved_successfully" : res?.mes || "save_failed"
		)
		this.tests = this.store.getSiteDataTable("tests")
	}

	async duplicateTest() {
		this.spinDup = true
		const res = await this.apiService.post("duplicate_test", {
			test_id: this.test?.id,
		})
		this.spinDup = false
		if (res?.tests) {
			res.tests.forEach((test) => {
				this.store.addGenItemRow("tests", test)
			})
		}
		if (res?.testquestions) {
			res.testquestions.forEach((testquestion) => {
				this.store.addGenItemRow("testquestions", testquestion)
			})
		}
		this.modalService.openToast("test_duplicated")
	}
}
